<p
    class="flex flex-nowrap align-items-baseline m-0 min-w-0 font-normal line-height-3 text-color-secondary">
    @for (part of parts; track $index) {
        @if (!$first) {
            <span class="flex-none mx-2 opacity-60" aria-hidden="true">·</span>
        }
        <span [class]="part.styleClass">{{ part.text }}</span>
    }
</p>
